import { UseMutationOptions, useMutation } from "@tanstack/react-query";

import { Auth } from "@/interfaces/domain/User";
import {
  SignupCompanyParams,
  SignupCustomerParams,
  signupCompanyRequest,
  signupCustomerRequest,
} from "@/services/api/signup";

export const useSignupCustomer = (
  options?: UseMutationOptions<Auth, unknown, SignupCustomerParams>
) => useMutation(signupCustomerRequest, options);

export const useSignupCompany = (
  options?: UseMutationOptions<Auth, unknown, SignupCompanyParams>
) => useMutation(signupCompanyRequest, options);
